import classNames from 'classnames'
import { Button } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'
import { ReactComponent as Logo } from 'assets/default/svg/logo.svg'
import { ReactComponent as LogoNouveau } from 'assets/default/svg/logo_nouveau.svg'
import { ReactComponent as PictoUser } from 'assets/default/svg/picto_user.svg'
import TripleGrow from 'components/Loading/TripleGrow'
import useUtilisateur from 'hooks/useUtilisateur'
import { Status } from 'redux/features/utilisateur/slice'
import Translation from 'assets/default/translation.json'
import s from './Header.module.scss'

const Header = (): JSX.Element => {
  const links = [
    {
      label: 'Accueil',
      to: '/',
    },
    {
      label: 'Etudier votre marché',
      to: '/etudier-votre-marche',
    },
    {
      label: 'Cibler biens à vendre',
      to: '/biens-a-vendre',
    },
    {
      label: 'Voir résultats en favoris',
      to: '/favoris',
    },
    {
      label: `Bien utiliser ${Translation.common.produit}`,
      to: '/bien-utiliser',
    },
  ]

  const { utilisateur, status } = useUtilisateur()
  const toggleNouveauLogo =
    process?.env?.REACT_APP_TOGGLE_NOUVEAU_LOGO === 'true'

  return (
    <header className={s.header}>
      <div className={s.top}>
        <Button className={s.user} variant="link">
          <PictoUser />
          {status === Status.Pending && <TripleGrow />}
          {status === Status.Succeeded &&
            utilisateur !== null &&
            `${utilisateur.prenom} ${utilisateur.nom}`}
        </Button>
        <Button className={s.logo} variant="link">
          {toggleNouveauLogo ? <LogoNouveau /> : <Logo />}
        </Button>
      </div>
      <nav className={s.nav}>
        <ul>
          {links.map(({ label, to }, idx) => (
            <li key={`${label}${idx}`}>
              <NavLink
                className={classNames({
                  [s.active]: window.location.pathname === to,
                })}
                to={to}
              >
                {label}
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </header>
  )
}

export default Header
